module.exports = __webpack_public_path__ + "static/media/HkZ4jFedH_resume(1).664b54a2.pdf";